import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ProductTitle.module.scss';

export function ProductTitle() {
  const { t } = useTranslation();
  return (
    <div className={styles.productTitle}>
      {t('ultra_fi_ultra')} <span className={styles.newLabel}>{t('ultra_new')}</span>
    </div>
  );
}

export function ProductTitleDescription() {
  const { t } = useTranslation();
  return <div className={styles.productTitleDescription}>{t('ultra_description')}</div>;
}
